import React, { useState } from "react";
import { httpRequest } from "../../utils/httpRequest";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";

const qs = (obj = {}) =>
  Object.entries(obj)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");

const CreateOrgModal = ({ isOpen, onClose, onCreated }) => {
  const [form, setForm] = useState({
    name: "",
    description: "",
    logo: null, // فایل لوگو
    logoPreview: "",
    owner: null, // user objectssss
  });
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const token = JSON.parse(localStorage.getItem("user"))?.token;

  const loadUsers = async (inputValue) => {
    if (!inputValue || inputValue.length < 2) return [];
    try {
      const url = `/user?${qs({ q: inputValue, limit: 10 })}`;
      const { data } = await httpRequest("GET", url, null, {
        "x-access-token": token,
      });
      return (data?.data?.items || []).map((u) => ({
        label: `${u.name}|${u.phone}`,
        value: u._id,
      }));
    } catch (e) {
      return [];
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setForm((f) => ({
      ...f,
      logo: file,
      logoPreview: URL.createObjectURL(file),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return toast.error("نام سازمان الزامی است");

    setLoading(true);
    try {
      // ارسال فرم دیتا برای آپلود فایل
      const fd = new FormData();
      fd.append("name", form.name.trim());
      fd.append("description", form.description.trim());
      if (form.logo) fd.append("logo", form.logo);
      if (form.owner?.value) fd.append("owner", form.owner.value);

      await httpRequest("POST", "/organization", fd, {
        "x-access-token": token,
        "Content-Type": "multipart/form-data",
      });

      toast.success("سازمان با موفقیت ایجاد شد");
      onCreated();
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.message || "خطا در ایجاد سازمان");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl shadow-lg w-full max-w-2xl p-6 space-y-4 max-h-[85vh] overflow-y-auto"
      >
        <h2 className="text-lg font-bold text-gray-800">ایجاد سازمان جدید</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* نام */}
          <div>
            <label className="block text-sm mb-1">نام سازمان *</label>
            <input
              name="name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="border rounded-md w-full px-3 py-2"
              required
            />
          </div>

          {/* توضیحات */}
          <div>
            <label className="block text-sm mb-1">توضیحات</label>
            <textarea
              name="description"
              value={form.description}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
              rows={3}
              className="border rounded-md w-full px-3 py-2"
            />
          </div>

          {/* لوگو */}
          <div>
            <label className="block text-sm mb-1">لوگوی سازمان</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="border rounded-md w-full px-3 py-2"
            />
            {form.logoPreview && (
              <img
                src={form.logoPreview}
                alt="لوگو"
                className="w-24 h-24 rounded-md mt-2 object-cover border"
              />
            )}
          </div>

          {/* انتخاب مالک */}
          <div>
            <label className="block text-sm mb-1">مالک سازمان</label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={loadUsers}
              value={form.owner}
              onChange={(v) => setForm((f) => ({ ...f, owner: v }))}
              placeholder="جستجو کاربر..."
              isClearable
            />
          </div>

          {/* دکمه‌ها */}
          <div className="flex justify-end gap-2 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 bg-gray-200 rounded-lg"
            >
              انصراف
            </button>
            <button
              type="submit"
              disabled={loading}
              className={`px-4 py-2 rounded-lg text-white bg-purple-600 hover:bg-purple-700 transition ${
                loading ? "opacity-60 cursor-not-allowed" : ""
              }`}
            >
              {loading ? "در حال ایجاد..." : "ایجاد سازمان"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateOrgModal;
